import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { GetCommentsParams, GetCommentsResult } from "@/components/comment/actions/types";
import { MasterSelect } from "@/components/common/MasterSelect";
import { useHomeComment } from "@/components/home/CommentList/hooks/useHomeComment";
import { useDebounceLoading } from "@/hooks/useDebounceLoading";

export const CommentList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetchCommentList = (
    params: Pick<GetCommentsParams, "category_id" | "primary_charge_id" | "area_id" | "device_id">,
    callback?: (res: GetCommentsResult) => void
  ) => {
    dispatch(actions.homeCommentList.getComments({ ...params, start: 1, limit: 20 }, callback));
  };
  const {
    fetching,
    comments,
    categoryId,
    primaryChargeId,
    areaId,
    deviceId,
    changeCategory,
    changePrimaryCharge,
    changeArea,
    changeDevice,
    categories,
    primaryCharges,
    areas,
    devices,
  } = useHomeComment(fetchCommentList);
  const { loading } = useDebounceLoading(fetching);

  return (
    <>
      <div className="flex items-center gap-[20px]">
        <h2 className="page-ttl">{t("comment_latest")}</h2>
        <div className="flex gap-[5px] flex-1 justify-between">
          <div className="w-full">
            <MasterSelect
              prefix="category"
              options={categories}
              value={categoryId}
              onChange={changeCategory}
              placeholder={t("machines_category")}
              isClearable={true}
            />
          </div>
          <div className="w-full">
            <MasterSelect
              prefix="primary_charge"
              options={primaryCharges}
              value={primaryChargeId}
              onChange={changePrimaryCharge}
              placeholder={t("primary_charge")}
              isClearable={true}
            />
          </div>
          <div className="w-full">
            <MasterSelect
              prefix="area"
              options={areas}
              value={areaId}
              onChange={changeArea}
              placeholder={t("area")}
              isClearable={true}
            />
          </div>
          <div className="w-full">
            <MasterSelect
              prefix="device"
              options={devices}
              value={deviceId}
              onChange={changeDevice}
              placeholder={t("device")}
              isClearable={true}
            />
          </div>
        </div>
      </div>
      {/* リスト */}
      <div className={`tbl-box h-[calc(100%-55px)] ${loading ? "loading loading--list" : ""}`}>
        {comments.length ? (
          <>
            <div className="tbl-head-adjusted">
              <table className="tbl-basic tbl-data">
                <thead>
                  <tr>
                    <th className="min-w-[130px] max-w-[130px]">{t("machines_category")}</th>
                    <th className="min-w-[130px] max-w-[130px]">{t("title")}</th>
                    <th className="min-w-[100px] max-w-[100px]">{t("process_title")}</th>
                    <th className="w-full">{t("comment")}</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="overflow-y-scroll h-[calc(100%-28px)]">
              <table className="tbl-basic tbl-data table-fixed">
                <tbody>
                  {comments.map((comment, index) => (
                    <tr key={index}>
                      <td className="w-130">{comment.category_name}</td>
                      <td className="w-130">{comment.item_name}</td>
                      <td className="w-100">{comment.process_name}</td>
                      <td className="w-full">{comment.comment}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : !loading ? (
          <p className="empty-message">{t("no_data")}</p>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};
